export enum CvBoxSectionEnum{
    Vip = 1,
    Premium = 2,
    Standard = 3
}